import { createSelector } from "@reduxjs/toolkit";
import { RootState } from "../reducer";
import { selectNotebookPages } from "./page";

export const selectPageSubPagesMap = (state: RootState) =>
  state.pages.pageSubPagesMap;

export const makeSelectSubPages = (pageId: string | undefined) =>
  createSelector(selectPageSubPagesMap, (pageSubPagesMap) =>
    pageId ? pageSubPagesMap[pageId] : undefined,
  );

// Module-scope selector: recomputes only when selectedNotebookPageId or notebookPages changes.
// Walks the ancestor chain of the selected page once and returns the full Set<string> of
// ancestor page IDs. Each useIsAncestorOfSelected call then does a cheap .has() lookup.
export const selectAncestorIds = createSelector(
  (state: RootState) => state.pages.selectedNotebookPageId,
  selectNotebookPages,
  (selectedId, pages): Set<string> => {
    if (!selectedId) return new Set();
    const ancestors = new Set<string>();
    const visited = new Set<string>();
    let folderId = pages[selectedId]?.["folder-id"];
    while (folderId && !visited.has(folderId)) {
      const page = pages[folderId];
      if (!page) break;
      ancestors.add(page["page-id"]);
      visited.add(folderId);
      folderId = page["folder-id"];
    }
    return ancestors;
  },
);
